Namespace 'Common.Sessions.Filters.SingleFilters'

class Common.Sessions.Filters.SingleFilters.ModalFilterView extends Backbone.View
  modal_filter_template: JST['backbone/templates/common/dashboard/filters/single_filters/modal_filter']

  events:
    'click .accept': 'accept'
    'click .close, .cancel': 'cancel'
    'click .clear-icon': '_disableClearInput'

  initialize: ({values, placeholder, title, selectedOptions, acceptButtonText, editable = true}) ->
    @editable = editable
    @values = values
    @placeholder = placeholder
    @title = title
    @selectedOptions = selectedOptions || []
    @acceptButtonText = acceptButtonText || I18n.t('customer_visual_mode.filters.multiple_values_filter.accept')

  render: ->
    @$el.html @modal_filter_template
      translations:
        title: @title
        accept: @acceptButtonText
        cancel: I18n.t('customer_visual_mode.filters.multiple_values_filter.cancel')
      editable: @editable
    modalView = new Common.Modals.ModalView
      title: @title
      contentView: @
      size:
        width: 650
        height: 530
      modalOptions:
        offset:
          y: 30
    modalView.render()
    @

  accept: =>
    @trigger('filters:multiplevalues:apply')
    @trigger('modal:close')

  getSelectedValues: ->
    throw new Error 'Not implemented'

  cancel: ->
    @trigger('modal:close')

  _setDisableAcceptButton: ({disabled}) ->
    @_acceptButton().prop('disabled', disabled)

  _acceptButton: ->
    @$el.find('.accept')

  _disableClearInput: ->
    @$el.find('.clear-icon').addClass('disabled')
